// src/services/companyService.js

import axiosInstance from "../config/axiosInstance";

const BASE_URL = "/company";

/**
 * Obtiene la lista paginada de empresas
 * @param {number} page - Número de página (inicia en 1)
 * @param {number} size - Cantidad de elementos por página
 * @param {string|null} searchTerm - Término de búsqueda (opcional)
 * @returns {Promise<ApiResponse<PaginatedResult<CompanyDto>>>}
 */
export const getCompanies = async (page = 1, size = 10, searchTerm) => {
  const params = new URLSearchParams({
    pageIndex: page.toString(),
    pageSize: size.toString(),
  });

  if (searchTerm?.trim()) {
    params.append("searchTerm", searchTerm.trim());
  }

  const response = await axiosInstance.get(
    `${BASE_URL}/paged?${params.toString()}`
  );
  return response.data;
};

/**
 * Obtiene una empresa por su ID
 * @param {string} id - ID de la empresa
 * @returns {Promise<ApiResponse<CompanyDto>>}
 */
export const getCompanyById = async (id) => {
  const response = await axiosInstance.get(`${BASE_URL}/${id}`);
  return response.data;
};

/**
 * Crea una nueva empresa
 * @param {CreateCompanyDto} data - Datos para la creación
 * @returns {Promise<ApiResponse<CompanyDto>>}
 */
export const createCompany = async (data) => {
  const response = await axiosInstance.post(BASE_URL, data);
  return response.data;
};

/**
 * Actualiza una empresa existente
 * @param {UpdateCompanyDto} data - Datos para actualizar
 * @returns {Promise<ApiResponse<boolean>>}
 */
export const updateCompany = async (data) => {
  const response = await axiosInstance.put(
    `${BASE_URL}/${data.companyId}`,
    data
  );
  return response.data;
};

/**
 * Elimina (soft delete) una empresa por ID
 * @param {string} id - ID de la empresa
 * @returns {Promise<ApiResponse<boolean>>}
 */
export const deleteCompany = async (id) => {
  const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return response.data;
};

export const getAllCompanies = async () => {
  const response = await axiosInstance.get(`${BASE_URL}`);
  return response.data;
};
